__turbopack_context__.v({
  "blockCardTrioSmall": "BlockCardTrioSmall-module-scss-module__2limMW__blockCardTrioSmall",
  "cards": "BlockCardTrioSmall-module-scss-module__2limMW__cards",
  "eyebrow": "BlockCardTrioSmall-module-scss-module__2limMW__eyebrow",
  "flushTop": "BlockCardTrioSmall-module-scss-module__2limMW__flushTop",
  "inner": "BlockCardTrioSmall-module-scss-module__2limMW__inner",
  "listItem": "BlockCardTrioSmall-module-scss-module__2limMW__listItem",
  "listItemGap": "BlockCardTrioSmall-module-scss-module__2limMW__listItemGap",
});
